import { createSlice } from "@reduxjs/toolkit";
import { getSpeedOfServicesFilteredData, getSpeedOfServicesReportList, resetSpeedOfServicesFilteredData } from "../services/speedofservicesServices";


let initialState = {
  isLoading: false,
  pages: 0,
  errors: null,

  data: [],
  // Filter data
  filteredData : []
};

const speedOfServicesReport = createSlice({
  name: "speedOfServicesReport",
  initialState,
  extraReducers: (builder) => {

  /* -------------------------------------------- Get CostAdjustment Reports List ------------------------------------ */
    builder.addCase(getSpeedOfServicesReportList.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    })
    builder.addCase(getSpeedOfServicesReportList.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || null;
      state.errors = null;
    })
    builder.addCase(getSpeedOfServicesReportList.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    })

   /* --------------------------------------------------------------------------------------------------- */
 /* --------------------------------------- Menu Engineering Filter Data ------------------------------*/
    builder.addCase(getSpeedOfServicesFilteredData.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(getSpeedOfServicesFilteredData.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.filteredData = payload;
      state.errors = null;
    });
    builder.addCase(getSpeedOfServicesFilteredData.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });
   /* -------------------------------------------------------------------------------------- */
    builder.addCase(resetSpeedOfServicesFilteredData.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(resetSpeedOfServicesFilteredData.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.filteredData = [];
      state.errors = null;
    });
    builder.addCase(resetSpeedOfServicesFilteredData.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });
   /* --------------------------------------------------------------------------------------------------- */
  }
});

export default speedOfServicesReport.reducer;